import { z } from "zod";
import {
  ACTIVITY_TYPE,
  APPLICABLE_GRADES,
  GRADES,
  MODULE,
  SUB_MODULE,
  TOPIC,
  TOPIC_TLM,
  YEAR,
} from "../consts";

export const schema = z.object({
  [MODULE]: z.string().optional(),
  [SUB_MODULE]: z.string().optional(),
  [TOPIC]: z.string().optional(),
  [YEAR]: z.string().optional(),
  [GRADES]: z.array(z.string()).optional(),
  [ACTIVITY_TYPE]: z.string().optional(),
  [TOPIC_TLM]: z.string().optional(),
  [APPLICABLE_GRADES]: z.array(z.string()).optional(),
});

export type formValues = z.infer<typeof schema>;
